import { useEffect } from "react";

import { useTypedQuery } from "hooks";
import { useNewsFilters } from "modules/NewsDashboard/components/NewsDashboardFilters/hooks";
import { LANGUAGE_OPTIONS } from "modules/NewsDashboard/hooks/useLanguageOptions";
import { NewsQueryKeys } from "modules/NewsDashboard/queryKeys";
import { ApiInstance } from "utils/Api";

import type { Article } from "models";
import type { NewsQueryResponse } from "modules/NewsDashboard/queryKeys";

const sortArticles = (articles: Article[]) =>
  articles.sort((a, b) => (a.publish_date === b.publish_date ? b.id - a.id : (a.publish_date || "") > (b.publish_date || "") ? -1 : 1));

const sortPaginatedArticles = (paginatedArticles: NewsQueryResponse) => ({ ...paginatedArticles, articles: sortArticles(paginatedArticles.articles) });

export const useNewsQuery = () => {
  const filters = useNewsFilters();

  const { data, isFetching, refetch } = useTypedQuery({
    queryKey: NewsQueryKeys.articles,
    queryFn: async ({ baseUrl, endpoint }) =>
      (await ApiInstance.post(endpoint, { ...filters, language_code: filters.language_code === LANGUAGE_OPTIONS.All ? null : filters.language_code }, baseUrl)).data,
    select: sortPaginatedArticles,
    enabled: false
  });

  useEffect(() => {
    refetch();
  }, [filters]);

  return { ...data, isLoading: isFetching, refetch };
};
